import React from 'react'

import chatScript from "../ChatScript.json"

import InnerBotAvatar from './InnerBotAvatar'

import BotMessage from '../BotMessage'

import UserMessage from '../UserMessage'

import { Button } from 'primereact/button'

import { MzInputText } from '../../components'

import { MzErrorMessage } from '../../components/form'

import Functions from '../utils/Functions'

import ValidationFunctions from '../utils/ValidationFunctions'


export default  function BotTextInput({ message, isLastBotMessage, setMessages, setIsTyping, messages, answers, setAnswers, urlBotImage , isAddressField= false }) {
    const [buttonDisabled, setButtonDisabled] = React.useState(true);
    const [errMessage, setErrMessage] = React.useState(null);

    function onClick(msg, setMessages, setIsTyping) {

        let value = document.getElementById("input_" + message.id).value

        const err =ValidationFunctions.validateAddress(value);
       // console.log("errori");
        //console.log(err);
        
        if(isAddressField==true &&  err !=null){
            setButtonDisabled(true);
           // alert("Indirizzo non valido");
            setErrMessage(err);
            return;
        }


        const newAnswers = { ...answers }
        newAnswers[msg.chiave_domanda] = value
        setAnswers(newAnswers)
        //  console.log(newAnswers)

        const next =  Functions.getMessageById(msg.prossima)

          // Aggiorna il messaggio corrente con il valore dell'input
          const updatedMessages = messages.map((msg) => {
            if (msg.id === message.id) {
                return { ...msg, inputValue: value };
            }
            return msg;
        });

  

        if (next) {
            setIsTyping(true)
            setTimeout(() => {
                //debugger
                setIsTyping(false)
                //setMessages((prevMessages) => [...prevMessages, next])
                setMessages([...updatedMessages, next]);
            }, 1000)
        }

       

   

    }

    function onChange(e) {
      //  console.log(e.target.value)
        if (e.target.value.length >= 2) {
            setButtonDisabled(false)
        } else {
            setButtonDisabled(true)
        }
    }

    return (
        <div key={"bot" + message.id} >
            <div className='grid'>
                <InnerBotAvatar urlBotImage={urlBotImage} message={message} isLastBotMessage={isLastBotMessage} />
                <div className='col-11'>
                    <BotMessage msg={message} isLastBotMessage={isLastBotMessage}></BotMessage>
                </div>


            </div>
            {!message.inputValue ? (
            <div className="grid">
                <div className='col-9 col-offset-1'>
                    <MzInputText onChange={onChange} stateValue={message.inputValue} placeholder={message.placeholder} id={"input_" + message.id} className={"ml-3"} ></MzInputText>
                    <MzErrorMessage error={errMessage} visible={errMessage}  className={"ml-3"} />
                </div>
                <div className='col-2 '>
                    <Button disabled={buttonDisabled} onClick={() => onClick(message, setMessages, setIsTyping)} className='ml-2' label='>' />
                </div>
            </div>
            )
             :  <UserMessage msg={message}></UserMessage>}

        </div>
    )
}
